import script from "./Pagination.vue?vue&type=script&lang=ts&setup=true"
export * from "./Pagination.vue?vue&type=script&lang=ts&setup=true"

import "./Pagination.vue?vue&type=style&index=0&id=2f62bb1c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f62bb1c"]])

export default __exports__